<div class="el-page">
    <div class="el-title">
        <h3>Reset your password</h3>
    </div>
    <form [formGroup]="resetForm" (ngSubmit)="requestReset()">
        <!-- honeypot: hidden from humans, filled by bots -->
        <input type="text" name="hp_field" [(ngModel)]="hpField" [ngModelOptions]="{standalone: true}"
            autocomplete="off" tabindex="-1" aria-hidden="true"
            style="position:absolute;left:-9999px;top:-9999px;width:1px;height:1px;overflow:hidden" />
        <div class="el-formframe">
            <p class="el-message">Enter your email address; a password reset link will be sent to you.</p>
            <mat-form-field class="el-inputfield">
                <mat-label>Email address</mat-label>
                <input matInput type="email" formControlName="email" placeholder="email address"
                    autocomplete="email">
                <mat-error>Enter a valid email address</mat-error>
            </mat-form-field>
            <div class="el-buttonframe">
                <button mat-raised-button color="primary" type="submit" class="el-button"
                    [disabled]="loading">Send reset link</button>
                <button mat-raised-button color="secondary" type="button" class="el-button"
                    (click)="backToLogin()">Back to login</button>
            </div>

            <p class="el-message">{{message}}
            </p>
        </div>
    </form>
</div>
